





(function () {
  var GEL_MSRP = 400; 
  var GIFT_VARIANTS = [47809958019177, 47810014019689]; 
  var cartHasSub = false; 
  var GIFT_TITLE_RE = /fueling guide|mystery gift/i;
  var QUARTERLY_PLAN = 1901527145;     
  var GIFT_HANDLE = { 47809958019177: 'fueling-guide', 47810014019689: 'mystery-gift' };
  var GIFT_DESC = { 
    47809958019177: 'A subscribers-only gift to jumpstart your HNY+ experience.',
    47810014019689: 'Surprise gifts added to your future shipments.'
  };
  var descCache = {};
  function giftKeyFromTitle(t) {
    if (/fueling guide/i.test(t)) return 47809958019177;
    if (/mystery gift/i.test(t)) return 47810014019689;
    return null;
  }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function packSize(item) {
    var m = String(item && item.title || '').match(/(\d+)\s*pack/i);
    return m ? parseInt(m[1], 10) : 0;
  }
  
  function unitStrike(it) {
    var cap = parseInt(it && it.compareAtPrice, 10);
    if (cap > 0) return cap;
    var cmp = it && it.properties && it.properties._cmp;
    if (cmp) return parseInt(cmp, 10);
    var ps = packSize(it);
    return ps > 0 ? ps * GEL_MSRP : 0;
  }

  
  function compute() {
    var cart = window.upcartGetCart && window.upcartGetCart();
    if (!cart || !cart.items || !cart.items.length) return null;
    var strike = 0;
    cart.items.forEach(function (it) {
      var qty = it.quantity || 1;
      var isGift = it.isGiftCard || it.isRewardItem || GIFT_TITLE_RE.test(it.title || '');
      var unit = isGift ? 0 : unitStrike(it);
      if (unit > 0) strike += unit * qty;
      else strike += (it.finalLinePrice || 0);
    });
    var actual = cart.total;
    if (!(strike > actual)) return null;
    return { strike: strike, actual: actual, pct: Math.round((strike - actual) / strike * 100) };
  }
  function decorateSubtotal() {
    var valEl = document.querySelector('[class*="cartSubtotalValue" i]');
    if (!valEl) return;
    var old = valEl.querySelector('.hny-disc');
    var d = compute();
    if (!d) { if (old) old.remove(); return; }
    
    
    var sig = d.pct + '|' + d.strike;
    if (old && old.getAttribute('data-hny-sig') === sig) return;
    if (old) old.remove();
    var wrap = document.createElement('span');
    wrap.className = 'hny-disc';
    wrap.setAttribute('data-hny-sig', sig);
    wrap.innerHTML =
      '<span class="hny-disc-pill"><span>' + d.pct + '% OFF</span></span>' +
      '<span style="position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0">Original subtotal </span>' +
      '<span class="hny-disc-strike">' + fmt(d.strike) + '</span>' +
      '<span style="position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0"> Discounted subtotal </span>';
    valEl.insertBefore(wrap, valEl.firstChild);
  }

  
  
  
  var SR = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
  function btnStrike(btn, d) {
    var own = [].slice.call(btn.childNodes).filter(function (n) { return n.nodeType === 3; })
      .map(function (n) { return n.nodeValue; }).join('');
    var m = own.match(/\$([\d,]+\.\d{2})\s*$/);
    var price = m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
    return d && price >= d.actual ? d.strike + (price - d.actual) : 0;
  }
  function checkoutStale() {
    var d = compute();
    return [].slice.call(document.querySelectorAll('.upcart-checkout-button')).some(function (btn) {
      var old = btn.querySelector('.hny-btn-strike'), want = btnStrike(btn, d);
      return want ? !old || old.getAttribute('data-hny-sig') !== String(want) : !!old;
    });
  }
  function decorateCheckout() {
    var d = compute();
    [].slice.call(document.querySelectorAll('.upcart-checkout-button')).forEach(function (btn) {
      var old = btn.querySelector('.hny-btn-strike'), want = btnStrike(btn, d);
      btn.classList.toggle('hny-has-strike', !!want); 
      if (want && old && old.getAttribute('data-hny-sig') === String(want)) return;
      if (old) old.remove();
      if (!want) return;
      var tn = [].slice.call(btn.childNodes).filter(function (n) { return n.nodeType === 3 && n.nodeValue.indexOf('$') !== -1; }).pop();
      if (!tn) return;
      var at = tn.nodeValue.lastIndexOf('$');
      var priceNode = at > 0 ? tn.splitText(at) : tn;
      var sp = document.createElement('span');
      sp.className = 'hny-btn-strike';
      sp.setAttribute('data-hny-sig', String(want));
      sp.innerHTML = '<span style="' + SR + '">Original total </span>' +
        '<s style="opacity:.55;font-weight:500;margin-right:6px">' + fmt(want) + '</s>' +
        '<span style="' + SR + '"> Discounted total </span>';
      btn.insertBefore(sp, priceNode);
    });
  }

  
  
  function hiddenPlan(li) {
    var cart = window.upcartGetCart && window.upcartGetCart();
    var lis = [].slice.call(document.querySelectorAll('.upcart-public-cart-item'));
    if (!cart || !cart.items || cart.items.length !== lis.length) return null;
    var pr = cart.items[lis.indexOf(li)] && cart.items[lis.indexOf(li)].properties;
    return pr && pr._plan ? pr : null;
  }
  function restyleLineItems() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      if (li.querySelector('.hny-li-detail')) return;
      var props = li.querySelector('.upcart-public-component-product-tile__properties');
      if (!props) return;
      
      var detailEl = [].slice.call(props.querySelectorAll('[class*="key-value-pair"]'))
        .filter(function (e) { return /supply\s*:|plan\s*:/i.test(e.textContent); })[0];
      if (!detailEl) {
        
        var hp = hiddenPlan(li);
        if (!hp) return;
        props.style.setProperty('display', 'none', 'important');
        var hd = document.createElement('div');
        hd.className = 'hny-li-detail';
        hd.innerHTML = '<span class="hny-li-l1">' + hp._plan + '</span>' + (hp._level ? '<span class="hny-li-l2">' + hp._level + '</span>' : '');
        props.parentNode.insertBefore(hd, props);
        return;
      }
      
      var levelEl = [].slice.call(props.querySelectorAll('[class*="key-value-pair"]'))
        .filter(function (e) { return /^\s*level\s*:/i.test(e.textContent); })[0];
      var raw = detailEl.textContent.trim();
      var ci = raw.indexOf(':');
      var left = (ci === -1 ? raw : raw.slice(0, ci)).trim();
      var right = ci === -1 ? '' : raw.slice(ci + 1).trim();
      var row1, months = 0;
      if (/supply/i.test(left)) {
        var freq = right.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        row1 = left + (freq ? ' / ' + freq : '');
        var days = parseInt((left.match(/(\d+)/) || [])[1], 10);
        months = days ? Math.round(days / 30) : 0;
      } else {
        
        row1 = (right.split(/\s+every\s+/i)[0] || '').trim();
        months = parseInt((right.match(/every\s+(\d+)/i) || [])[1], 10);
      }
      var delivery = months ? (months <= 1 ? 'Delivered every month' : 'Delivered every ' + months + ' months') : '';
      
      
      props.style.setProperty('display', 'none', 'important');
      var det = document.createElement('div');
      det.className = 'hny-li-detail';
      var row2 = levelEl ? levelEl.textContent.trim().replace(/^level\s*:\s*/i, '') : delivery;
      det.innerHTML = '<span class="hny-li-l1">' + row1 + '</span>' +
        (row2 ? '<span class="hny-li-l2">' + row2 + '</span>' : '');
      props.parentNode.insertBefore(det, props);
    });
  }

  
  function labelGifts() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      var title = li.querySelector('.upcart-public-component-product-tile__product-title');
      var isGift = title && GIFT_TITLE_RE.test(title.textContent);
      if (!isGift) return;
      li.classList.add('hny-gift-item'); 
      var oldLbl = li.querySelector('.hny-freegift-label'); if (oldLbl) oldLbl.remove();
      if (li.querySelector('.hny-freegift-pill')) return;
      var priceGroup = li.querySelector('.upcart-public-component-product-tile__price-group');
      if (!priceGroup) return;
      var pill = document.createElement('span');
      pill.className = 'upcart-internal-component-tag upcart-public-component-tag hny-freegift-pill';
      pill.innerHTML = '<span class="upcart-internal-component-tag__icon upcart-public-component-tag__icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></span>' +
        '<span class="upcart-internal-component-tag__text upcart-public-component-tag__text">FREE GIFT</span>';
      priceGroup.appendChild(pill); 
    });
  }

  
  function fetchDesc(vid) {
    var h = GIFT_HANDLE[vid];
    if (!h || descCache[vid]) return;
    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.description) return;
        var tmp = document.createElement('div'); tmp.innerHTML = p.description;
        var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt) return;
        descCache[vid] = txt;
        document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
          var title = li.querySelector('.upcart-public-component-product-tile__product-title');
          if (title && giftKeyFromTitle(title.textContent) === vid) {
            var el = li.querySelector('.hny-freegift-desc'); if (el) el.textContent = txt;
          }
        });
      }).catch(function () {});
  }
  function describeGifts() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      var title = li.querySelector('.upcart-public-component-product-tile__product-title');
      if (!title) return;
      var vid = giftKeyFromTitle(title.textContent);
      if (!vid || li.querySelector('.hny-freegift-desc')) return;
      var d = document.createElement('div');
      d.className = 'hny-freegift-desc';
      d.textContent = descCache[vid] || GIFT_DESC[vid];
      
      var priceGroup = li.querySelector('.upcart-public-component-product-tile__price-group')
        || li.querySelector('.upcart-public-component-product-tile__price');
      if (priceGroup && priceGroup.parentNode) priceGroup.parentNode.insertBefore(d, priceGroup);
      else title.parentNode.insertBefore(d, title.nextSibling);
      if (!descCache[vid]) fetchDesc(vid);
    });
  }

  
  function disableItemLinks() {
    document.querySelectorAll('.upcart-public-cart-item a[href*="/products/"]').forEach(function (a) {
      if (a.dataset.hnyNolink) return;
      a.dataset.hnyNolink = '1';
      a.removeAttribute('href');
      a.setAttribute('tabindex', '-1');
      a.style.pointerEvents = 'none';
      a.style.cursor = 'default';
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    });
  }

  function injectGuarantee() {
    var btn = document.querySelector('.upcart-checkout-button');
    if (!btn || !btn.parentElement) return;
    if (document.querySelector('.hny-guarantee')) return;
    var el = document.createElement('div');
    el.className = 'hny-guarantee';
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>Money-back guarantee</span>';
    btn.parentElement.insertBefore(el, btn.nextSibling);
  }

  
  var guardBusy = false;
  function enforceGiftGuard() {
    if (guardBusy) return;
    guardBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(function (it) { return GIFT_VARIANTS.indexOf(it.variant_id) !== -1; });
        if (!gifts.length) { guardBusy = false; return; }
        var hasQuarterly = (cart.items || []).some(function (it) {
          if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1) return false;
          var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
          return sp && (sp.id === QUARTERLY_PLAN || /3\s*month|90.?day|quarter/i.test(sp.name || ''));
        });
        if (hasQuarterly) { guardBusy = false; return; }
        var updates = {};
        gifts.forEach(function (g) { updates[g.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { guardBusy = false; if (window.upcartRefreshCart) window.upcartRefreshCart(); });
      })
      .catch(function () { guardBusy = false; });
  }

  function needsApply() {
    if (checkoutStale()) return true;
    if (!document.querySelector('[class*="cartSubtotalValue" i] .hny-disc') && compute()) return true;
    if (document.querySelector('.upcart-checkout-button') && !document.querySelector('.hny-guarantee')) return true;
    var rw = document.querySelector('.upcart-public-rewards');
    if (rw) {
      var rm = rw.querySelector('.upcart-public-rewards__message');
      if (cartHasSub && rm && rm.getAttribute('data-hny-ship') !== '1') return true;
      if (!cartHasSub && rw.classList.contains('hny-ship-free')) return true;
    }
    var sc = window.upcartGetCart && window.upcartGetCart();
    var slis = [].slice.call(document.querySelectorAll('.upcart-public-cart-item'));
    if (sc && sc.items && sc.items.length === slis.length && slis.some(function (li, i) {
      var t = li.querySelector('.upcart-public-component-product-tile__product-title');
      if (t && GIFT_TITLE_RE.test(t.textContent)) return false;
      var ce = li.querySelector('.upcart-public-component-product-tile__price-compare-at');
      return ce && ce.getAttribute('data-hny-strike') !== String(unitStrike(sc.items[i]));
    })) return true;
    if (document.querySelector('.upcart-public-cart-item a[href*="/products/"]')) return true;
    var giftTitles = [].slice.call(document.querySelectorAll('.upcart-public-component-product-tile__product-title'))
      .filter(function (t) { return GIFT_TITLE_RE.test(t.textContent); });
    if (giftTitles.some(function (t) { return !t.closest('.upcart-public-cart-item').querySelector('.hny-freegift-pill'); })) return true;
    if (giftTitles.some(function (t) { return !t.closest('.upcart-public-cart-item').querySelector('.hny-freegift-desc'); })) return true;
    return [].slice.call(document.querySelectorAll('.upcart-public-cart-item')).some(function (li) {
      if (li.querySelector('.hny-li-detail')) return false;
      if (hiddenPlan(li)) return true;
      var props = li.querySelector('.upcart-public-component-product-tile__properties');
      if (!props) return false;
      return [].slice.call(props.querySelectorAll('[class*="key-value-pair"]'))
        .some(function (e) { return /supply\s*:|plan\s*:/i.test(e.textContent); });
    });
  }
  
  function fixItemStrikes() {
    var cart = window.upcartGetCart && window.upcartGetCart();
    if (!cart || !cart.items) return;
    var lis = document.querySelectorAll('.upcart-public-cart-item');
    if (lis.length !== cart.items.length) return; 
    cart.items.forEach(function (it, i) {
      var li = lis[i]; if (!li) return;
      if (GIFT_TITLE_RE.test(it.title || '')) return; 
      var strike = unitStrike(it); 
      var el = li.querySelector('.upcart-public-component-product-tile__price-compare-at');
      
      
      
      if (el && el.getAttribute('data-hny-strike') !== String(strike)) {
        el.setAttribute('data-hny-strike', String(strike));
        if (strike) el.textContent = fmt(strike);
      }
    });
  }

  
  function fixShippingBar() {
    var rewards = document.querySelector('.upcart-public-rewards');
    if (!rewards) return;
    var msg = rewards.querySelector('.upcart-public-rewards__message');
    if (cartHasSub) {
      rewards.classList.add('hny-ship-free');
      if (msg && msg.getAttribute('data-hny-ship') !== '1') {
        msg.setAttribute('data-hny-ship', '1');
        msg.innerHTML = 'Free shipping unlocked!';
      }
    } else {
      rewards.classList.remove('hny-ship-free');
      if (msg) msg.removeAttribute('data-hny-ship');
    }
  }
  function refreshShipFlag() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (it) { return GIFT_VARIANTS.indexOf(it.variant_id) === -1; });
        cartHasSub = items.length > 0 && items.every(function (it) { return !!it.selling_plan_allocation; });
        fixShippingBar();
      }).catch(function () {});
  }
  function applyAll() { decorateSubtotal(); decorateCheckout(); restyleLineItems(); labelGifts(); describeGifts(); disableItemLinks(); injectGuarantee(); fixShippingBar(); fixItemStrikes(); }

  function boot() {
    applyAll();
    enforceGiftGuard();
    refreshShipFlag();
    try {
      if (window.upcartSubscribeCartLoaded) window.upcartSubscribeCartLoaded(function () { applyAll(); enforceGiftGuard(); refreshShipFlag(); });
      if (window.upcartSubscribeCartUpdated) window.upcartSubscribeCartUpdated(function () { applyAll(); enforceGiftGuard(); refreshShipFlag(); });
      if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(function () { setTimeout(applyAll, 60); });
    } catch (e) {}
    var pop = document.getElementById('CartPopup');
    if (pop && window.MutationObserver) {
      
      
      
      var pending = false;
      new MutationObserver(function () {
        if (pending || !needsApply()) return;
        pending = true;
        setTimeout(function () { pending = false; if (needsApply()) applyAll(); }, 50);
      }).observe(pop, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') setTimeout(boot, 800);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 800); });
})();





(function () {
  function patch() {
    var hosts = document.querySelectorAll('savedby-checkout-plus');
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (!root) continue;
      var out = root.querySelector('a.sb__non-covered-link:not([href])');
      if (out && !out.hasAttribute('tabindex')) { out.setAttribute('tabindex', '0'); out.setAttribute('role', 'link'); }
      var help = root.querySelector('.sb__info-help-button');
      if (help && !help.hasAttribute('tabindex')) { help.setAttribute('tabindex', '0'); help.setAttribute('role', 'button'); help.setAttribute('aria-label', 'About package protection'); }
      if (!root.hnyKeys) {
        root.hnyKeys = true;
        root.addEventListener('keydown', function (e) {
          var t = e.target;
          if (!t || !t.matches) return;
          if (e.key === 'Enter' && t.matches('a.sb__non-covered-link')) { e.preventDefault(); t.click(); }
          else if ((e.key === 'Enter' || e.key === ' ') && t.matches('.sb__info-help-button')) { e.preventDefault(); t.click(); }
        });
      }
    }
  }
  var queued = false;
  function later() { if (queued) return; queued = true; setTimeout(function () { queued = false; patch(); }, 300); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') patch(); }, true);
  document.addEventListener('focusin', later, true);
  function hook() {
    try {
      if (window.upcartSubscribeCartLoaded) window.upcartSubscribeCartLoaded(later);
      if (window.upcartSubscribeCartUpdated) window.upcartSubscribeCartUpdated(later);
      if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(later);
    } catch (e) {}
    later();
  }
  if (document.readyState !== 'loading') setTimeout(hook, 800);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(hook, 800); });
})();










(function () {
  var root = document.documentElement, pop = null, wrap = null;
  var lastOutside = null, lastShift = false, timer = null, retries = 0, statusEl = null, statusTimer = null, tries = 0;
  function off() { return !!window.hnyCartA11yOff; }
  function onSlide(e) { if (e.target === pop && e.propertyName !== 'visibility') wake(); }
  function find() {
    if (pop && pop.isConnected) return true;
    pop = document.getElementById('CartPopup');
    wrap = document.getElementById('UpcartPopup');
    if (!pop) return false;
    pop.addEventListener('transitionrun', onSlide);
    pop.addEventListener('transitionstart', onSlide);
    if (!pop.hasAttribute('role')) pop.setAttribute('role', 'dialog');
    if (!pop.hasAttribute('aria-label')) pop.setAttribute('aria-label', 'Cart');
    
    if (window.IntersectionObserver) {
      try {
        new IntersectionObserver(function (en) { for (var i = 0; i < en.length; i++) if (en[i].isIntersecting) { wake(); return; } }).observe(pop);
      } catch (e) {}
    }
    return true;
  }
  function vendorOpen() {
    return document.body.classList.contains('upcartPopupShow') || !!(wrap && wrap.classList.contains('upcartPopupShow')) || /styles_active/.test(String(pop.className));
  }
  function offscreen() {
    var r = pop.getBoundingClientRect();
    var vw = root.clientWidth || window.innerWidth;   
    return r.width === 0 || r.height === 0 || r.left >= vw - 1 || r.right <= 1 || r.top >= window.innerHeight - 1 || r.bottom <= 1;
  }
  function inDrawer(el) {   
    while (el) { if (el === pop) return true; el = el.parentNode || el.host; }
    return false;
  }
  function deepActive() {
    var a = document.activeElement;
    while (a && a.shadowRoot && a.shadowRoot.activeElement) a = a.shadowRoot.activeElement;
    return a;
  }
  function settle() {
    timer = null;
    if (off() || !find()) { root.classList.remove('hny-cart-idle'); return; }
    if (vendorOpen()) {
      root.classList.remove('hny-cart-idle');
      retries = 0;
      return;
    }
    if (!offscreen()) {   
      root.classList.remove('hny-cart-idle');
      if (retries < 3) { retries++; timer = setTimeout(settle, 1000); }
      return;
    }
    retries = 0;
    var a = deepActive();
    if (a && inDrawer(a)) {   
      var back = (lastOutside && lastOutside.isConnected && lastOutside.getClientRects().length) ? lastOutside : null;
      if (!back || (back.matches && back.matches('input, textarea, select, [contenteditable]'))) back = document.getElementById('cart-icon-bubble');   
      var sx = window.pageXOffset, sy = window.pageYOffset;
      try { if (back) back.focus({ preventScroll: true }); } catch (e) {}
      if (window.pageXOffset !== sx || window.pageYOffset !== sy) window.scrollTo(sx, sy);
    }
    root.classList.add('hny-cart-idle');
  }
  function wake() {   
    root.classList.remove('hny-cart-idle');
    if (timer) clearTimeout(timer);
    timer = setTimeout(settle, 600);
  }
  function onFocusIn(e) {
    if (off() || !find()) return;
    var t = e.target;
    if (!t || t === document.body || inDrawer(t)) return;
    if (!vendorOpen() || offscreen()) { lastOutside = t; return; }
    

    if (!t.closest || !t.closest('#MainContent, .shopify-section-group-header-group, .shopify-section-group-footer-group, .skip-to-content-link')) return;
    var list = pop.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), items = [], i;
    for (i = 0; i < list.length; i++) {
      if (list[i].tabIndex >= 0 && !list[i].disabled && list[i].type !== 'hidden' && list[i].getClientRects().length) items.push(list[i]);
    }
    var to = items.length ? (lastShift ? items[items.length - 1] : items[0]) : pop;
    try { to.focus({ preventScroll: true }); } catch (err) {}
  }
  function announce() {
    if (off() || !find() || !vendorOpen()) return;
    if (statusTimer) clearTimeout(statusTimer);
    statusTimer = setTimeout(function () {
      var c = null;
      try { c = window.upcartGetCart && window.upcartGetCart(); } catch (e) {}
      if (!c || !c.items || typeof c.items.length !== 'number') return;
      var count = 0, i;
      for (i = 0; i < c.items.length; i++) count += (c.items[i].quantity || 0);
      if (!statusEl) return;
      var msg = count === 0 ? 'Cart is empty.'
        : 'Cart updated: ' + count + (count === 1 ? ' item' : ' items') + (typeof c.total === 'number' ? ', subtotal $' + (c.total / 100).toFixed(2) : '') + '.';
      statusEl.textContent = msg;
      setTimeout(function () { if (statusEl.textContent === msg) statusEl.textContent = ''; }, 5000);
    }, 700);
  }
  function firstSettle() { if (find()) wake(); else if (tries++ < 20) setTimeout(firstSettle, 1500); }
  function init() {
    if (off()) return;
    statusEl = document.createElement('div');   
    statusEl.id = 'hny-cart-status';
    statusEl.setAttribute('role', 'status');
    statusEl.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
    document.body.appendChild(statusEl);
    document.addEventListener('pointerdown', function (e) { if (pop && !inDrawer(e.target)) lastOutside = null; }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') lastShift = !!e.shiftKey;
      else if (e.key === 'Escape') wake();
    }, true);
    document.addEventListener('focusin', onFocusIn, true);
    if (window.MutationObserver) new MutationObserver(wake).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    try {
      if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(wake);
      if (window.upcartSubscribeCartClosed) window.upcartSubscribeCartClosed(wake);
      if (window.upcartSubscribeCartLoaded) window.upcartSubscribeCartLoaded(wake);
      if (window.upcartSubscribeCartUpdated) window.upcartSubscribeCartUpdated(function () { wake(); announce(); });
    } catch (e) {}
    firstSettle();
  }
  if (document.readyState !== 'loading') setTimeout(init, 900);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 900); });
})();
